module.exports = __webpack_public_path__ + "img/instagram.d8adba5a.svg";